/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';


import moment from 'moment';
import { AxiosPost, ResultAPI } from 'service/CommonFunction/TS_function';

/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { ColorCMM, ColorGSM, ColorNGR, ColorNGV } from '../../FixColor';

am4core.addLicense("CH208466903");


const BAbarChart = (props) => {

    const { sBA, data } = props

    useEffect(() => {
        if (data && data.length > 0) {
            data.forEach(itemHead => {
                if (itemHead.lstGraph.length > 0) {
                    itemHead.lstGraph.forEach(itemChild => {
                        onRenderGraphStackBar(itemChild.lstData, itemChild.sId, itemHead.sId, itemChild.nMaxScore, itemChild.sQuestionair, itemHead.sTitle);
                    });
                }
            });
        }
    }, [data])

    const onRenderGraphStackBar = (data, index, sId, nMaxScore, sTitle, itemHeadTitle) => {
        let chart = am4core.create(`bar-ba${sId}_${index}`, am4charts.XYChart);

        let title = chart.titles.create();
        title.text = sTitle;
        title.fontSize = 16;
        title.marginBottom = 0;
        title.align = "left";
        title.fontWeight = '400';

        var colorSet = new am4core.ColorSet();
        if (sId == "1") {
            colorSet.list = [ColorCMM()].map(color => {
                return am4core.color(color);
            });
        } else if (sId == "2") {
            colorSet.list = [ColorGSM()].map(color => {
                return am4core.color(color);
            });
        } else if (sId == "3") {
            colorSet.list = [ColorNGR()].map(color => {
                return am4core.color(color);
            });
        } else if (sId == "4") {
            colorSet.list = [ColorNGV()].map(color => {
                return am4core.color(color);
            });
        }

        chart.colors = colorSet;

        // Add data
        chart.data = data;

        // chart.legend = new am4charts.Legend();
        // chart.legend.position = "right";

        // Create axes
        let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "name";
        categoryAxis.renderer.grid.template.opacity = 0;

        let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;
        valueAxis.max = nMaxScore;
        valueAxis.strictMinMax = true;
        valueAxis.renderer.grid.template.opacity = 0;
        valueAxis.renderer.ticks.template.strokeOpacity = 0.5;
        valueAxis.renderer.ticks.template.stroke = am4core.color("#495C43");
        valueAxis.renderer.ticks.template.length = 10;
        valueAxis.renderer.line.strokeOpacity = 0.5;
        valueAxis.renderer.baseGrid.disabled = true;
        valueAxis.renderer.minGridDistance = 40;

        // Create series
        function createSeries(field) {
            let series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueX = field;
            series.dataFields.categoryY = "name";
            series.columns.template.tooltipText = "{categoryY}: {valueX}";
        }
        createSeries("value");

        setTimeout(() => {
            chart.exporting.getImage("png").then((data) => {
                let obj = {
                    id: index,
                    nOrder: index + 1,
                    sDesc: "Div 3 job bar 6",
                    sName: itemHeadTitle,
                    idDiv: 5,
                    imgBase64: data
                }
                props.exportImg && props.exportImg(obj);
            });
        }, 2000);
    }


    return (
        <>
            <div className='div-border'>
                <Grid container spacing={1} direction="row" justifyContent="center" alignItems="start" >
                    <Grid item xs={12}>
                        <Typography style={{ fontWeight: 500 }}>กลุ่มตลาด: {sBA}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <div id='SatisFactiondiv5' style={{ padding: '8px' }}>
                            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="start" >
                                {
                                    data && data.length > 0 ?
                                        <>
                                            {
                                                data.map((itemHead, index) => {
                                                    return (
                                                        <Fragment key={`g-head-ba_${index}`}>
                                                            <Grid item xs={12} sm={6} md={3}>
                                                                <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                                                                    <Grid item xs={12} style={{ textAlign: "center" }}>
                                                                        <Typography style={{ color: '#000000' }}><b>{itemHead.sTitle}</b></Typography>
                                                                    </Grid>
                                                                    {
                                                                        itemHead.lstGraph.length > 0 ?
                                                                            itemHead.lstGraph.map((itemChild, index) => {
                                                                                return (
                                                                                    <Fragment key={`g-child-ba${itemHead.sId}_${index}`}>
                                                                                        {/* <Grid item xs={12}>
                                                                                            <Typography>{itemChild.sQuestionair}</Typography>
                                                                                        </Grid> */}
                                                                                        <Grid item xs={12}>
                                                                                            <div id={`bar-ba${itemHead.sId}_${index + 1}`} style={{ width: "100%", height: "120px" }}></div>
                                                                                        </Grid>
                                                                                    </Fragment>
                                                                                )
                                                                            })
                                                                            : null
                                                                    }
                                                                </Grid>
                                                            </Grid>
                                                        </Fragment>

                                                    )
                                                })
                                            }
                                        </>
                                        :
                                        null
                                }
                            </Grid>
                        </div>
                    </Grid>

                </Grid>
            </div>
        </>
    )
}

export default BAbarChart


// [
//     {
//         sTitle: "CMM",
//         sId: "1",
//         lstGraph: [
//             {
//                 sId: "1",
//                 sQuestionair: "ความพึงพอใจในคุณภาพการให้บริการ",
//                 nMaxScore: 5,
//                 lstData: [
//                     {
//                         "name": "คะแนน",
//                         "value": 2.5,
//                     }
//                 ],
//             },
//             {
//                 sId: "2",
//                 sQuestionair: "ความรวดเร็วในการให้บริการของเจ้าหน้าที่",
//                 nMaxScore: 5,
//                 lstData: [
//                     {
//                         "name": "คะแนน",
//                         "value": 3,
//                     }
//                 ],
//             },
//             {
//                 sId: "3",
//                 sQuestionair: "ความสะดวกในการติดต่อสื่อสารกับเจ้าหน้าที่",
//                 nMaxScore: 5,
//                 lstData: [
//                     {
//                         "name": "คะแนน",
//                         "value": 5,
//                     }
//                 ],
//             },
//         ]
//     },
//     {
//         sTitle: "GSM",
//         sId: "2",
//         lstGraph: [
//             {
//                 sId: "1",
//                 sQuestionair: "ความพึงพอใจในคุณภาพการให้บริการ",
//                 nMaxScore: 5,
//                 lstData: [
//                     {
//                         "name": "คะแนน",
//                         "value": 2.5,
//                     }
//                 ],
//             },
//             {
//                 sId: "2",
//                 sQuestionair: "ความรวดเร็วในการให้บริการของเจ้าหน้าที่",
//                 nMaxScore: 5,
//                 lstData: [
//                     {
//                         "name": "คะแนน",
//                         "value": 3,
//                     }
//                 ],
//             },
//             {
//                 sId: "3",
//                 sQuestionair: "ความสะดวกในการติดต่อสื่อสารกับเจ้าหน้าที่",
//                 nMaxScore: 5,
//                 lstData: [
//                     {
//                         "name": "คะแนน",
//                         "value": 5,
//                     }
//                 ],
//             },
//         ]
//     },
//     {
//         sTitle: "NGR",
//         sId: "3",
//         lstGraph: [
//             {
//                 sId: "1",
//                 sQuestionair: "ความพึงพอใจในคุณภาพการให้บริการ",
//                 nMaxScore: 5,
//                 lstData: [
//                     {
//                         "name": "คะแนน",
//                         "value": 2.5,
//                     }
//                 ],
//             },
//             {
//                 sId: "2",
//                 sQuestionair: "ความรวดเร็วในการให้บริการของเจ้าหน้าที่",
//                 nMaxScore: 5,
//                 lstData: [
//                     {
//                         "name": "คะแนน",
//                         "value": 3,
//                     }
//                 ],
//             },
//             {
//                 sId: "3",
//                 sQuestionair: "ความสะดวกในการติดต่อสื่อสารกับเจ้าหน้าที่",
//                 nMaxScore: 5,
//                 lstData: [
//                     {
//                         "name": "คะแนน",
//                         "value": 5,
//                     }
//                 ],
//             },
//         ]
//     },
//     {
//         sTitle: "NGV",
//         sId: "4",
//         lstGraph: [
//             {
//                 sId: "1",
//                 sQuestionair: "ความพึงพอใจในคุณภาพการให้บริการ",
//                 nMaxScore: 5,
//                 lstData: [
//                     {
//                         "name": "คะแนน",
//                         "value": 2.5,
//                     }
//                 ],
//             },
//             {
//                 sId: "2",
//                 sQuestionair: "ความรวดเร็วในการให้บริการของเจ้าหน้าที่",
//                 nMaxScore: 5,
//                 lstData: [
//                     {
//                         "name": "คะแนน",
//                         "value": 3,
//                     }
//                 ],
//             },
//             {
//                 sId: "3",
//                 sQuestionair: "ความสะดวกในการติดต่อสื่อสารกับเจ้าหน้าที่",
//                 nMaxScore: 5,
//                 lstData: [
//                     {
//                         "name": "คะแนน",
//                         "value": 5,
//                     }
//                 ],
//             },
//         ]
//     },

// ]